import React from 'react';
import {RequestOrdersListType} from '../../types/TypesStore';
import {validationFilterForm} from '../../assets/utils/validation';
import {Form, Formik} from 'formik';
import LightGreenButton from '../Buttons/LightGreenButton';
import GreenButton from '../Buttons/GreenButton';
import FromDateToDateFilter from './Components/FromDateToDateFilter';
import {firstDayNextMonth, monthNow} from '../../assets/utils/dateUtils';
import {useTranslation} from 'react-i18next';

type Props = {
	active: boolean;
	setActive: (active: boolean) => void;
	setFilters: (filters: RequestOrdersListType) => void;
};
const FinancialStatFilter: React.FC<Props> = ({
	active,
	setActive,
	setFilters,
}) => {
	const {t} = useTranslation();
	const initialValues = {
		from_date: '',
		to_date: '',
	};
	const handleSubmit = (values: typeof initialValues) => {
		setFilters(values);
		setActive(false);
	};
	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'}`}
		>
			<div className="item-filter__wrapper">
				<Formik
					enableReinitialize
					validationSchema={validationFilterForm}
					initialValues={initialValues}
					onSubmit={handleSubmit}
				>
					{({handleSubmit, resetForm}) => {
						return (
							<Form
								onSubmit={handleSubmit}
								className="item-filter__form form-filter"
							>
								<FromDateToDateFilter
									toDateFieldName={'to_date'}
									byDateFieldName={'from_date'}
								/>

								<div className="item-filter__buttons">
									<LightGreenButton text={t('застосувати')} type={'submit'} />
									<GreenButton
										text={t('скасувати фільтр')}
										type={'button'}
										onClick={() => {
											setFilters({
												from_date: monthNow(),
												to_date: firstDayNextMonth(),
											});
											resetForm();
										}}
									/>
								</div>
							</Form>
						);
					}}
				</Formik>
			</div>
		</div>
	);
};

export default FinancialStatFilter;
